import React from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';
import Card from '../Molecules/Card';

import { getContentSubType, removeImageStyleFromSvgUrl } from '../../helpers';

const SearchItem = ({ item, type = null, includeDate = false }) => {
  const classes = classNames('Content__Row col-12 col-md-6 col-lg-4');
  const immutableItem = Immutable.fromJS(item.fields);
  const itemType = immutableItem.getIn(['type', 0], type);
  const title = immutableItem.getIn(['title', 0]);
  const summary = immutableItem.getIn(['summary', 0], immutableItem.getIn(['body', 0, 'summary'], immutableItem.getIn(['body', 0, 'processed'], immutableItem.getIn(['body', 0], immutableItem.getIn(['term_summary', 0])))));
  const milestoneSummary = immutableItem.getIn(['milestone_summary', 0], '');
  const bodyText = itemType === 'milestones' ? milestoneSummary : summary;
  const url = immutableItem.getIn(['url', 0]);
  const imageStyleUri = removeImageStyleFromSvgUrl(immutableItem.getIn(['image_style_uri', 0], null));
  const created = immutableItem.getIn(['created', 0], '');
  const publicationDate = immutableItem.getIn(['field_publication_date', 0], '');
  let subTypeTranslationKey = itemType;
  // Check if a subType is connected to this item
  const subTypeFieldExists = immutableItem.getIn([`${getContentSubType(itemType)}_name`], null);
  if (subTypeFieldExists && subTypeFieldExists.size > 0) {
    subTypeTranslationKey = subTypeFieldExists.get(0).toLowerCase();
  }
  if (itemType === 'milestones') {
    subTypeTranslationKey = immutableItem.getIn(['field_milestone_label', 0], null);
  }

  return (
    <div className={classes}>
      <Card
        title={title}
        body={bodyText}
        image={imageStyleUri}
        alt=""
        type={itemType}
        subType={subTypeTranslationKey}
        link={url}
        created={includeDate ? (publicationDate || created) : null}
      />
    </div>
  );
};

export default SearchItem;
